export const INTERVENTION_STATUSES = [
  { key: 'requested', label: 'Demandée' },
  { key: 'estimating', label: 'À chiffrer' },
  { key: 'quoted', label: 'Devis envoyé' },
  { key: 'accepted', label: 'Acceptée' },
  { key: 'in_progress', label: 'En cours' },
  { key: 'on_hold', label: 'En attente' },
  { key: 'completed', label: 'Terminée' },
  { key: 'cancelled', label: 'Annulée' },
];

export const INTERVENTION_PRIORITIES = [
  { key: 'low', label: 'Basse' }, { key: 'normal', label: 'Normale' },
  { key: 'high', label: 'Haute' }, { key: 'urgent', label: 'Urgente' },
];

const STATUS_BY_KEY = new Map(INTERVENTION_STATUSES.map((status) => [status.key, status]));
const INTERVENTION_TRANSITIONS = {
  requested: ['estimating', 'cancelled'], estimating: ['quoted', 'cancelled'],
  quoted: ['accepted', 'estimating', 'cancelled'], accepted: ['in_progress', 'cancelled'],
  in_progress: ['on_hold', 'completed', 'cancelled'], on_hold: ['in_progress', 'cancelled'],
  completed: [], cancelled: [],
};
export const getInterventionStatus = (key) => STATUS_BY_KEY.get(key) || STATUS_BY_KEY.get('requested');
export const getAllowedInterventionTransitions = (key) => INTERVENTION_TRANSITIONS[key] || [];
export const createEmptyIntervention = (overrides = {}) => ({ affairId: '', name: '', description: '', contactId: '', assignedUserId: '', priority: 'normal', desiredDueDate: '', estimatedAmount: '', estimatedHours: '', notes: '', ...overrides });
const toNumber = (value) => value === '' || value === null || value === undefined ? 0 : Number(String(value).replace(',', '.'));
export const interventionToPayload = (form) => ({
  affairId: form.affairId || null, name: form.name?.trim() || '', description: form.description?.trim() || null,
  contactId: form.contactId || null, assignedUserId: form.assignedUserId || null, priority: form.priority || 'normal',
  desiredDueDate: form.desiredDueDate || null, estimatedAmount: toNumber(form.estimatedAmount),
  estimatedHours: toNumber(form.estimatedHours), notes: form.notes?.trim() || null,
});
